import { Link, NavLink } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useCart } from "../../cart/CartContext";
import "./Header.css";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const menuButtonRef = useRef(null);
  const { totals } = useCart();

  const closeNavigation = () => {
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    if (!mobileMenuOpen) return undefined;

    const closeWithEscape = (event) => {
      if (event.key !== "Escape") return;

      setMobileMenuOpen(false);
      menuButtonRef.current?.focus();
    };

    document.addEventListener("keydown", closeWithEscape);
    return () => document.removeEventListener("keydown", closeWithEscape);
  }, [mobileMenuOpen]);

  return (
    <header className="site-header">
      <Link to="/" className="site-logo-link" onClick={closeNavigation}>
        <img
          src="/images/branding/logo_imalandia.png"
          alt="Imalandia"
          width="500"
          height="500"
          decoding="async"
          className="site-logo"
        />
      </Link>

      <button
        ref={menuButtonRef}
        type="button"
        className="mobile-menu-button"
        onClick={() => setMobileMenuOpen((isOpen) => !isOpen)}
        aria-label={mobileMenuOpen ? "Cerrar menú" : "Abrir menú"}
        aria-expanded={mobileMenuOpen}
        aria-controls="site-navigation"
      >
        ☰
      </button>

      <nav
        id="site-navigation"
        className={`site-nav ${mobileMenuOpen ? "site-nav-open" : ""}`}
        aria-label="Navegación principal"
      >
        <NavLink to="/" onClick={closeNavigation}>
          Inicio
        </NavLink>

        <NavLink
          to="/imanes-personalizados-con-fotos"
          onClick={closeNavigation}
          className="site-nav-cta"
        >
          Crear imanes
        </NavLink>

        <NavLink
          to="/collage-magnetico-personalizado"
          onClick={closeNavigation}
        >
          Collage
        </NavLink>

        <NavLink
          to="/marcos-para-imanes-personalizados"
          onClick={closeNavigation}
        >
          Marcos
        </NavLink>

        <NavLink to="/ofertas" onClick={closeNavigation}>
          Ofertas
        </NavLink>

        <NavLink to="/tienda" onClick={closeNavigation}>
          Tienda
        </NavLink>

        <NavLink to="/contacto" onClick={closeNavigation}>
          Contacto
        </NavLink>

        <NavLink
          to="/carrito"
          onClick={closeNavigation}
          className="site-nav-cart"
          aria-label={`Carrito, ${totals.totalQuantity} ${
            totals.totalQuantity === 1 ? "producto" : "productos"
          }`}
        >
          Carrito
          <span aria-hidden="true">{totals.totalQuantity}</span>
        </NavLink>
      </nav>
    </header>
  );
}
